import React, {FC} from 'react';

import {WorkspacesEditorDialogsEnum} from '../context/types';
import {useWorkspacesEditor} from '../context/workspacesEditorContext';
import {DiscardWorkspacesChangesDialog} from './discardWorkspacesChangesDialog';
import {WorkspacesConflictDialog} from './workspacesConflictDialog';
import {WorkspacesSaveErrorDialog} from './workspacesSaveErrorDialog';

/*
 * Component.
 */

export const WorkspacesEditorDialogs: FC = () => {
  const {visibleDialog} = useWorkspacesEditor();

  return (
    <>
      {visibleDialog === WorkspacesEditorDialogsEnum.DISCARD && <DiscardWorkspacesChangesDialog />}
      {visibleDialog === WorkspacesEditorDialogsEnum.CONFLICT && <WorkspacesConflictDialog />}
      {visibleDialog === WorkspacesEditorDialogsEnum.ERROR && <WorkspacesSaveErrorDialog />}
    </>
  );
};
